/**
 * @license
 * Copyright (c) 2021-present, FriendliAI Inc. All rights reserved.
 */

export type PathsType = {
  [index: string]: string;
};

export const defaultPaths = (base: string) => ({
  default: `${base}`,
  pattern: `${base}/*`,
  getMenuPattern: `${base}/:current/*`,
});

export const omitDefaultPaths = (paths: string[]) => {
  const basePaths = new Set(Object.keys(defaultPaths('')));

  return paths.filter((path) => basePaths.has(path) === false);
};
